import brunchOjs1 from "../../img/brunch1.webp";
import brunchOjs2 from "../../img/brunch2.webp";
import brunchOjs3 from "../../img/brunch3.webp";
import brunchOjs4 from "../../img/brunch4.webp";
import concertsOjs1 from "../../img/concerts1.webp";
import concertsOjs2 from "../../img/concerts2.webp";
import concertsOjs3 from "../../img/concerts3.webp";
import concertsOjs4 from "../../img/concerts4.webp";
import happyHour1 from "../../img/picture-ojs-14.webp";
import happyHour2 from "../../img/picture-ojs-2.webp";

const happyHourDescriptionFr =
    'Du mardi au vendredi de 18h à 20h !<br/><br/>Profitez d’un moment convivial autour de nos boissons à prix doux. Et chaque jeudi, c’est notre Happy Day : les tarifs Happy Hour sont prolongés toute la soirée !<br/><br/><b><u>Tarifs Happy Hour :</u></b><br/>Bière : 7 €<br/>Cocktail : 8 €<br/>Mocktail : 6 €<br/><br/>Rendez-vous entre amis ou collègues pour partager un verre dans une ambiance détendue et festive.';

const happyHourDescriptionEn =
    'From Tuesday to Friday from 6pm to 8pm !<br/><br/>Enjoy a convivial moment around our drinks at low prices. And every Thursday, it’s our Happy Day : the Happy Hour rates are extended all evening !<br/><br/><b><u>Happy Hour rates :</u></b><br/>Beer : 7 €<br/>Cocktail : 8 €<br/>Mocktail : 6 €<br/><br/>Meet friends or colleagues to share a drink in a relaxed and festive atmosphere.';

const brunchDescriptionFr =
    'Venez découvrir notre <b>brunch à volonté</b>, entre élégance du <i>petit déjeuner à la française et générosité des saveurs italiennes</i>, autour d’une formule buffet à volonté à <b>35€</b> (15€ par enfant). Laissez-vous transporter dans une atmosphère détendue pour savourer votre <u>dimanche en toute gourmandise</u> !';

const brunchDescriptionEn =
    'Discover our <b>all-you-can-eat brunch</b>, blending the elegance of a <i>French breakfast with the generosity of Italian flavours</i>, with an all-you-can-eat buffet at <b>€35</b> (€15 per child). Relax and enjoy your <u>Sunday in pure indulgence</u>!';

const concertsDescriptionFr =
    'Certains soirs, laissez-vous porter par l’ambiance de nos concerts live. Des artistes en <i>solo</i> ou en <i>duo</i> accompagnent votre dîner avec un répertoire varié, pour une soirée conviviale, chaleureuse et pleine de musique.';

const concertsDescriptionEn =
    'On some evenings, let yourself be carried away by the atmosphere of our live concerts. Artists <i>solo</i> or <i>duo</i> accompany your dinner with a varied repertoire, for a convivial, warm and musical evening.';

export const newsData = [
    {
        title_fr: 'Happy Hour !',
        title_en: 'Happy Hour !',
        description_fr: happyHourDescriptionFr,
        description_en: happyHourDescriptionEn,
        img: happyHour1,
    },
    {
        title_fr: 'Notre brunch du Dimanche',
        title_en: 'Our Sunday Brunch',
        description_fr: brunchDescriptionFr,
        description_en: brunchDescriptionEn,
        img: brunchOjs1,
    },
    {
        title_fr: 'Concerts Live',
        title_en: 'Live concerts',
        description_fr: concertsDescriptionFr,
        description_en: concertsDescriptionEn,
        img: concertsOjs1,
    },
    {
        title_fr: 'Happy Hour !',
        title_en: 'Happy Hour !',
        description_fr: happyHourDescriptionFr,
        description_en: happyHourDescriptionEn,
        img: happyHour2,
    },
    {
        title_fr: 'Notre brunch du Dimanche',
        title_en: 'Our Sunday Brunch',
        description_fr: brunchDescriptionFr,
        description_en: brunchDescriptionEn,
        img: brunchOjs2,
    },
    {
        title_fr: 'Concerts Live',
        title_en: 'Live concerts',
        description_fr: concertsDescriptionFr,
        description_en: concertsDescriptionEn,
        img: concertsOjs2,
    },
    {
        title_fr: 'Happy Hour !',
        title_en: 'Happy Hour !',
        description_fr: happyHourDescriptionFr,
        description_en: happyHourDescriptionEn,
        img: happyHour1,
    },
    {
        title_fr: 'Notre brunch du Dimanche',
        title_en: 'Our Sunday Brunch',
        description_fr: brunchDescriptionFr,
        description_en: brunchDescriptionEn,
        img: brunchOjs3,
    },
    {
        title_fr: 'Concerts Live',
        title_en: 'Live concerts',
        description_fr: concertsDescriptionFr,
        description_en: concertsDescriptionEn,
        img: concertsOjs3,
    },
    {
        title_fr: 'Happy Hour !',
        title_en: 'Happy Hour !',
        description_fr: happyHourDescriptionFr,
        description_en: happyHourDescriptionEn,
        img: happyHour2,
    },
    {
        title_fr: 'Notre brunch du Dimanche',
        title_en: 'Our Sunday Brunch',
        description_fr: brunchDescriptionFr,
        description_en: brunchDescriptionEn,
        img: brunchOjs4,
    },
    {
        title_fr: 'Concerts Live',
        title_en: 'Live concerts',
        description_fr: concertsDescriptionFr,
        description_en: concertsDescriptionEn,
        img: concertsOjs4,
    },
];
